"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FilterPenalized", {
  enumerable: true,
  get: function get() {
    return _FilterPenalized.FilterPenalized;
  }
});
var _FilterPenalized = require("./FilterPenalized");